import React  from 'react';  

export const patientsConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/patients',
        component: React.lazy(() => import('./PatientsList')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/patients/view-records',
        component: React.lazy(() => import('./PatientRecords')),
      },
    ],
  },
 
];